import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetTeamList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/teams${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetTeam = async function(teamPublicId, locationId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/team/${teamPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const UpdateTeam = async function(team) {
    try {
        const { publicId } = team
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/team/${publicId}`,
            data: team,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const PostTeam = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/team`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeleteTeam = async function({ teamPublicId, locationPublicId }) {
    try {
        if (teamPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: teamPublicId')
            )
        if (locationPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationPublicId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/location/${locationPublicId}/team/${teamPublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeTeamStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/team/${publicId}/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
